var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((20),function(index){return [_c('b-form-group',{attrs:{"label":`Level ${index}`,"label-size":"sm","label-cols-sm":1}},[_c('b-form-input',{attrs:{"type":"number"},model:{value:(_vm.value[index-1]),callback:function ($$v) {_vm.$set(_vm.value, index-1, _vm._n($$v))},expression:"value[index-1]"}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }